import React from 'react'
import { Row, Col, Button } from 'react-bootstrap'
import LearningResourcesFilters from '../filters'
import LearningResourcesListPaginated from '../paginated-list'
import LearningResourceCard from '../card'
import FullSplitTemplate from '../../screen-templates/full-split'
import LearningResourcesCard from '../card'
import AdminButtons from './admin-buttons'
import CreateButton from './create-button'

const Item = ({ resource }) => {
    return (
        <Col
            xs={12}
            style={{ padding: '10px'}}
        >
            <AdminButtons resource={resource} />
            <LearningResourcesCard resource={resource} />
        </Col>
    )
}

const LearningResourcesManagerDesktop = () => {
    return (
        <FullSplitTemplate>
            <FullSplitTemplate.Main>
                <Row>
                    <Col style={{ display: 'flex', alignItems: 'center'}}>
                        <div style={{ flexGrow: '1', display: 'flex', alignItems: 'center' }}>
                            <h1>Learning Resources</h1>
                        </div>
                        <div><CreateButton /></div>
                    </Col>
                </Row>
                <LearningResourcesListPaginated itemComponent={Item} pageSize={10} />
            </FullSplitTemplate.Main>
            <FullSplitTemplate.Bar>
                <LearningResourcesFilters />
            </FullSplitTemplate.Bar>
        </FullSplitTemplate>
    )
}

export default LearningResourcesManagerDesktop